@keyframes ddsSkeletonAnimation {
  0% {
    opacity: 1;
  }
  to {
    opacity: 0.5;
  }
}

.container {
  animation: ddsSkeletonAnimation var(--dds-motion-animation-skeleton);
  background-color: var(--dds-color-surface-skeleton);

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 0.8;
  }
}
